import {ApiError} from '@spa/api';

import {BaseException} from './base.exception';

export class InitialDataValidationException extends BaseException {
    constructor(messages: string[], statuses: number[] = [], errors: ApiError[] = []) {
        super(messages, statuses, errors);
    }
}
